import script from "./CourseStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseStudent.vue?vue&type=script&setup=true&lang=js"

import "./CourseStudent.vue?vue&type=style&index=0&id=6d797483&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d797483"]])

export default __exports__